import { serviceModesConstants } from '../../_constants';

export function serviceModes(state = {}, action) {
    switch (action.type) {
        case serviceModesConstants.SERVICE_MODES_FETCHING:
            return {
                ...state,
                serviceModeFetching: true
            };
        case serviceModesConstants.SERVICE_MODES_FETCHED:
            return {
                ...state,
                serviceModeFetching: false
            };
        case serviceModesConstants.SERVICE_MODES_SUBMITTING:
            return {
                ...state,
                serviceModeSubmitting: true
            };
        case serviceModesConstants.SERVICE_MODES_SUBMITTED:
            return {
                ...state,
                serviceModeSubmitting: false
            };
        case serviceModesConstants.GET_SERVICE_MODES:
            return {
                ...state,
                serviceModes: action.serviceModes
            };
        case serviceModesConstants.GET_SERVICE_MODE_BY_ID:
            return {
                ...state,
                serviceMode: action.serviceMode
            };
        case serviceModesConstants.GET_ACTIVE_SERVICE_MODES:
            return {
                ...state,
                activeServiceModes: action.activeServiceModes,
            };
        default:
            return state;
    }
}